import * as Yup from 'yup';

export const validateSchema = (schema: Yup.ObjectSchema<any>, key: string, values: any) => {
  if (!schema || !key || !values) return;

  try {
    schema.validateSyncAt(key, values, { stripUnknown: true, abortEarly: false });
    return true;
  } catch (_error) {
    return false;
  }
};

export const validateSync = (
  schema: Yup.ObjectSchema<any> | Yup.ArraySchema<any[] | undefined, Yup.AnyObject, undefined, ''>,
  values: any,
) => {
  if (!schema || !values) return;

  try {
    schema.validateSync(values, { stripUnknown: true, abortEarly: false });
    return true;
  } catch (_error) {
    return false;
  }
};

export const getAllInvalidFieldNames = (schema: Yup.ObjectSchema<any>, data: any) => {
  let errors = {};
  for (const key in data) {
    const isValid = validateSchema(schema, key, data);
    if (!isValid) {
      errors = { ...errors, [key]: !isValid };
    }
  }
  return errors;
};

export const getAllInvalidFieldNamesAuto = (schema: Yup.ObjectSchema<any>, data: any) => {
  if (!schema || !data) return;

  try {
    schema.validateSync(data, {
      stripUnknown: true,
      abortEarly: false,
    });
    return [];
  } catch (err: unknown) {
    const errors: Record<string, boolean> = {};
    if (!(err instanceof Yup.ValidationError)) {
      return errors;
    }
    err.inner.forEach((error) => {
      if (error.path) errors[error.path] = true;
    });

    return errors;
  }
};
